module.exports = __webpack_public_path__ + "img/arsenal.20c5a666.png";